import { render, staticRenderFns } from "./yewubanli.vue?vue&type=template&id=57318795&"
import script from "./yewubanli.vue?vue&type=script&lang=js&"
export * from "./yewubanli.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports